import { EUserRoleActionTypes, ISetUserRoleAction } from '../../actions/userRole';
import { TUserRole } from '../../types/currentUser';

export function userRoleReducer(state: TUserRole = null, action: ISetUserRoleAction): TUserRole {
  switch (action.type) {
    case EUserRoleActionTypes.SetUserRole:
      return action.payload;
    default:
      return state;
  }
}
